import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=60a239fc&scoped=true&lang=pug&"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=60a239fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a239fc",
  null
  
)

export default component.exports